import Single from './Single';
import Multiselect from './Multiselect';

const ModalDuplicate = ({ isMultiselect, ...rest }) => {
  return isMultiselect ? <Multiselect {...rest} /> : <Single {...rest} />;
};

export default ModalDuplicate;
